import { useState } from "react";
import { registerUser } from "../services/authService";
import { useNavigate, Link } from "react-router-dom";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // Phase 1: Silent Opt-in for matrimonial features
  const [isLooking, setIsLooking] = useState(false); 
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      // Send the matrimonial flag along with core data
      await registerUser({ 
        name, 
        email, 
        password, 
        matrimonialProfile: { isPublic: isLooking } 
      });
      alert("Registration successful! Please log in.");
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Register</h2>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <input
        type="text"
        placeholder="Full Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />

      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />

      {/* Phase 1: Subtle Matrimonial Integration */}
      <div style={{ margin: "10px 0", fontSize: "0.9rem" }}>
        <label>
          <input
            type="checkbox"
            checked={isLooking}
            onChange={(e) => setIsLooking(e.target.checked)}
          />
          {" "}Enable Matrimonial Discovery (Optional)
        </label>
      </div>

      <button type="submit">Register</button>

      <p>
        Already have an account? <Link to="/login">Login here</Link>
      </p>
    </form>
  );
}
